import {NgModule} from "@angular/core";
import {LazyBildelastingDirektiv_ArbeidskøTjeneste_DI_TOKEN, LazyBildelastingDirektiv_ElementSynlighetObservering_DI_TOKEN} from "web-ng2/delt/direktiver/lazyBildelasting/lazyBildelasting";
import {Arbeidskø} from "felles-ng2/tjenester/Arbeidskø";
import {ElementSynlighetObservering} from "felles-ng2/tjenester/ElementSynlighetObservering";

@NgModule({
    providers: [
        {provide: LazyBildelastingDirektiv_ArbeidskøTjeneste_DI_TOKEN, useValue: new Arbeidskø(10).startKonsumering()},
        {provide: LazyBildelastingDirektiv_ElementSynlighetObservering_DI_TOKEN, useValue: new ElementSynlighetObservering({avregistrerEtterFørsteSynlig: true})},
    ]
})
export class DelteDirektiverModul {

}
